export const getCaption = (element) => element.getIn(['content', 'caption']);
export const getShowCaption = (element) => element.getIn(['content', 'showCaption']) || false;
